import classNames from 'classnames';

import styles from './Paper.module.scss';

interface Props {
  flex?: boolean;
  flexItemWide?: boolean;
  children?: React.ReactNode;
}

const Paper: React.FC<Props> = ({
  children,
  flex = false,
  flexItemWide = false,
}) => (
  <div
    className={classNames(styles.paper, {
      [styles.flex]: flex,
      [styles.flexItemWide]: flexItemWide,
    })}
  >
    {children}
  </div>
);

export default Paper;
